import { AfterViewInit, Component, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatListComponent } from 'src/app/common/components/matlist/matList-section.component';
import { ScrollFocusService } from 'src/app/common/services/scroll-focus.service';
import { MktTaggingTransformationService } from 'src/app/core/services';
import { getBrowserNameForTagging } from '../../utility/browser-util';

@Component({
  selector: 'app-citi-shop-faq',
  templateUrl: './citi-shop-faq.component.html',
  styleUrls: ['./citi-shop-faq.component.scss'],
  standalone: false
})
export class CitiShopFaqComponent implements OnInit, AfterViewInit {
  expandAll: boolean = false;
  label: string;
  faqSection;
  faqsState: Array<boolean>;
  @ViewChildren('citishopFaq') citishopFaq: QueryList<MatListComponent>;

  @Input() contentFaq: any = '{}';
  @Input() contentHeader: any = {};
  @Input() isUserEnrolled : boolean = false;

  constructor(
    private _mktTaggingTransformationService: MktTaggingTransformationService,
    private route: ActivatedRoute,
    private _scrollFocusService: ScrollFocusService
  ) { }

  ngOnInit(): void {
    this.faqSection = this.contentFaq;
    this.label = this.faqSection.expandAllText;
    this.faqsState = Array(this.faqSection?.faqs?.length).fill(false)
  }

  ngAfterViewInit(): void {
    if(this.contentHeader?.adBlockerFAQScrollItem && this.contentHeader?.adBlockerQueryParam){
      this.faqScrollTo(this.contentHeader.adBlockerFAQScrollItem, this.contentHeader.adBlockerQueryParam);
    }
    if(this.contentHeader?.vcnFAQScrollItem && this.contentHeader?.vcnQueryParam){
      this.faqScrollTo(this.contentHeader.vcnFAQScrollItem, this.contentHeader.vcnQueryParam);
    }
  }

  faqScrollTo(itemNo: string, queryParam: string){
    const paramKey = queryParam.split('=')?.[0];
    const paramValue = queryParam.split('=')?.[1];
    const routerParam = this.route.snapshot.queryParams?.[paramKey];
    if(routerParam===paramValue){
      const faqItem: number = Number(itemNo)-1;
      const FAQ: MatListComponent = this.citishopFaq.filter(t=> Number(t.item)===(faqItem))?.[0];
      FAQ?.toggleContent();
      setTimeout(()=>this._scrollFocusService.scrollFocus({},`#accordion-`+faqItem),2000);
    }
  }

  toggleExpandAll() {
    this.label = null;
    this.expandAll = !this.expandAll;
    this.label = this.expandAll ? this.faqSection.collapseAllText : this.faqSection.expandAllText;
    if (this.expandAll) {
      this._expandAllTagging()
      this.faqsState = this.faqsState.map(_ => true)
    } else {
      this.faqsState = this.faqsState.map(_ => false)
    }
  }

  onFAQClick(index: number, faqTitle: string) {
    this._showFAQTagging(index+1, faqTitle)
  }

  onSeeAllFAQsClick() {
    this._seeAllFAQsTagging()
    window.open(this.faqSection.seeAllFaqsUrl);
  }

  private _seeAllFAQsTagging() {
    const tagObj = {
      'form_type': getBrowserNameForTagging(this.isUserEnrolled),
    }
    this._mktTaggingTransformationService.tagMktCompareCards('citishop_landing_seeallfaqs', tagObj)
  }

  private _showFAQTagging(index: number, faqTitle: string) {
    this.faqsState[index] = !this.faqsState[index];
    const tagObj = {
      'page_inter': `${index}|${faqTitle}`,
      'form_type': getBrowserNameForTagging(this.isUserEnrolled),
    }
    if (this.faqsState[index]) {
      this._mktTaggingTransformationService.tagMktCompareCards('citishop_landing_showfaq', tagObj)
    }
  }

  private _expandAllTagging() {
    const tagObj = {
      'form_type': getBrowserNameForTagging(this.isUserEnrolled),
    }
    this._mktTaggingTransformationService.tagMktCompareCards('citishop_landing_expandall', tagObj)
  }
}
